export default "__VITE_ASSET__B$enhtvR__"